<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title>{{data.dialogTitle}}</h2>

<mat-dialog-content>
    <h3 *ngIf="data.subTitle != null" mat-dialog-title>{{data.subTitle}}</h3>

    @if (data.securityApprovalMethod === securityApprovalMethodType.PERCENT_RULE) {
        <div class="approval-note">{{'RECOVERY_KEY_ACCESS_DIALOG_APPROVAL_NOTE' | translate : {percent: data.minimumApprovalPercentRequired} }}</div>
    } @else {
        <div class="approval-note">{{'RECOVERY_KEY_ACCESS_DIALOG_APPROVAL_NOTE_PLUS_ONE' | translate}}</div>
    }
    <div class="contact-note">{{'RECOVERY_KEY_ACCESS_DIALOG_CONTACT_NOTE' | translate}}</div>

    <div class="container">
        <ng-container *ngFor="let approver of data.results">
            <div class="approver-wrapper">
                <div>
                    <h1 class="title">{{approver.firstName}} {{approver.lastName}}</h1>
                    <p class="content">{{approver.email}}</p>
                </div>
                <div class="icon-wrapper">
                    <span class="mdi mdi-check-circle-outline" aria-hidden="true" *ngIf="approver.status == Status.APPROVED"></span>
                    <span class="mdi mdi-close-circle-outline" aria-hidden="true" *ngIf="approver.status == Status.DENIED"></span>
                </div>
            </div>
        </ng-container>
    </div>
</mat-dialog-content>
<div mat-dialog-actions class="button-wrapper">
    @if (data.requestStatus == Status.PENDING) {
        <button mat-raised-button color="warn" (click)="onButtonClick()" type="button">
            {{'RECOVERY_KEY_ACCESS_STATUS_DIALOG_CANCEL' | translate}}
        </button>
    } @else if (data.requestStatus == Status.APPROVED) {
        <button mat-raised-button color="warn" (click)="onButtonClick()" type="button">
            {{'ACCEPT' | translate}}
        </button>
    }
    <button mat-raised-button color="primary" (click)="close()" type="button">{{'H_CLOSE' | translate}}</button>
</div>
